import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import supabase from '../lib/supabase'

const PORTAL_SESSION_KEY = 'codevaro_portal_session'

export default function ClientPortalInvite() {
  const { token } = useParams()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [inviteInfo, setInviteInfo] = useState(null)
  const [form, setForm] = useState({
    password: '',
    confirmPassword: ''
  })

  useEffect(() => {
    if (token) {
      validateInvite()
    } else {
      setError('Δεν βρέθηκε token πρόσκλησης.')
      setLoading(false)
    }
  }, [token])

  async function validateInvite() {
    try {
      setLoading(true)
      setError('')

      const { data, error: rpcError } = await supabase.rpc(
        'codevaro_client_portal_validate_invite',
        {
          p_invite_token: token
        }
      )

      if (rpcError) throw rpcError

      const info = data?.[0]
      if (!info?.access_id) {
        throw new Error('Μη έγκυρη πρόσκληση ή έχει ήδη ενεργοποιηθεί.')
      }

      setInviteInfo(info)
    } catch (err) {
      console.error(err)
      setError(err.message || 'Σφάλμα επαλήθευσης πρόσκλησης.')
    } finally {
      setLoading(false)
    }
  }

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setSaving(true)
      setError('')

      if (form.password.length < 6) {
        throw new Error('Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.')
      }

      if (form.password !== form.confirmPassword) {
        throw new Error('Οι κωδικοί δεν ταιριάζουν.')
      }

      const { data, error: rpcError } = await supabase.rpc(
        'codevaro_client_portal_accept_invite',
        {
          p_invite_token: token,
          p_password: form.password
        }
      )

      if (rpcError) throw rpcError

      const session = data?.[0]
      if (!session?.session_token) {
        throw new Error('Δεν δημιουργήθηκε session.')
      }

      localStorage.setItem(PORTAL_SESSION_KEY, session.session_token)
      navigate('/portal', { replace: true })
    } catch (err) {
      console.error(err)
      setError(err.message || 'Σφάλμα ενεργοποίησης λογαριασμού.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-lg">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Client Portal</h1>
        <p className="text-sm text-gray-600 mb-6">
          Ενεργοποίηση πρόσκλησης portal.
        </p>

        {loading ? (
          <div className="flex flex-col items-center justify-center py-8">
            <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-blue-600"></div>
            <p className="mt-4 text-sm text-gray-600">Γίνεται έλεγχος πρόσκλησης...</p>
          </div>
        ) : error ? (
          <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-red-700">
            {error}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="rounded-lg bg-gray-50 p-4">
              <div className="text-sm text-gray-500">Πελάτης</div>
              <div className="font-medium text-gray-900">{inviteInfo?.client_name || '—'}</div>

              <div className="mt-2 text-sm text-gray-500">Επαφή</div>
              <div className="font-medium text-gray-900">
                {inviteInfo?.contact_name || inviteInfo?.email || '—'}
              </div>
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Νέος Κωδικός
              </label>
              <input
                type="password"
                value={form.password}
                onChange={(e) =>
                  setForm((prev) => ({ ...prev, password: e.target.value }))
                }
                className="w-full rounded-lg border border-gray-300 px-3 py-2"
                required
                autoComplete="new-password"
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Επιβεβαίωση Κωδικού
              </label>
              <input
                type="password"
                value={form.confirmPassword}
                onChange={(e) =>
                  setForm((prev) => ({ ...prev, confirmPassword: e.target.value }))
                }
                className="w-full rounded-lg border border-gray-300 px-3 py-2"
                required
                autoComplete="new-password"
              />
            </div>

            <button
              type="submit"
              disabled={saving}
              className="w-full rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:opacity-50"
            >
              {saving ? 'Αποθήκευση...' : 'Ενεργοποίηση Portal'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}